module.exports = __webpack_public_path__ + "static/media/6.2-startups.7483562e.png";